module.exports = __webpack_public_path__ + "fonts/lato-black.6080b596.woff2";